export enum UserStatus {
    None = 0,
    Inactive = 1,
    PendingDocument = 2,
    PendingApproval = 3,
    Active = 4,
}
